import * as React from 'react'
import LocalizationStore from '../../../../Stores/LocalizationStore'
import { Button } from 'react-bootstrap'
import { history } from '../../../../Routing'
import Form, { ISubmitEvent } from 'react-jsonschema-form'
import { observer } from 'mobx-react'

export interface IGetExternalDataByPINFormProps {
    localizationStore?: LocalizationStore,
    className?: string
}

@observer
export default class ExternalDataSearchByPINView
    extends React.Component<IGetExternalDataByPINFormProps> {

    constructor(props: any) {
        super(props)
    }

    schema: Object = {
        'type': 'object',
        'properties': {
            'PIN': {
                'title': LocalizationStore.getInstance().t('Enter PIN'),
                'type': 'string'
            }
        }
    }

    submit(e: ISubmitEvent<any>) {
        history.push('/externalData/searchByPIN/' + e.formData['PIN'])
    }

    render() {
        const self = this
        let ls = LocalizationStore.getInstance()

        return (
            <div className="searchBlock">
                <Form
                    onSubmit={(e) => self.submit(e)}
                    schema={self.schema}
                >
                    <div className="searchBtn">
                        <Button type="submit">{ls.t!('SearchBtn')}</Button>
                    </div>
                </Form>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/ExternalData/ExternalDataSearchViews/ExternalDataSearchByPINView.tsx